import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectEnquiryComponent } from './project-enquiry.component';
import { RouterModule } from '@angular/router';
import {
  MatTabsModule, MatSelectModule, MatOptionModule, MatIconModule, MatDatepickerModule, MatExpansionModule,
  MatTableModule, MatCardModule, MatFormFieldModule, MatInputModule, MatCheckboxModule
} from '@angular/material';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/primeng';
import { MaterialModule } from 'app/shared/material.module';

const routes = [
  { path: '', redirectTo: 'project-enquiry', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'project-enquiry', component: ProjectEnquiryComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [ProjectEnquiryComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    // MatSelectModule,
    // MatOptionModule,
    BrowserAnimationsModule,
    // MatDatepickerModule,
    // MatIconModule,
    // MatExpansionModule,
    // MatTableModule,
    // MatTabsModule,
    // MatCardModule,
    // MatFormFieldModule,
    // FormsModule,
    // ReactiveFormsModule,
    // MatInputModule,
    CalendarModule,
    // FormsModule,
    // MatCheckboxModule
    MaterialModule
  ]
})
export class ProjectEnquiryModule { }
